import { render } from "./Button.vue?vue&type=template&id=1c2313cb"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c2313cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c2313cb', __exports__)) {
    api.reload('1c2313cb', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=1c2313cb", () => {
    api.rerender('1c2313cb', render)
  })

}


export default __exports__